<template>
    <v-dialog v-model="dialog" max-width="1200" min-height="250" max-height="650" persistent>
      <v-card class="pa-3" style="border-radius: 20px;">
        <!-- <v-card-title class="text-h6">
          QC Details
        </v-card-title> -->
        <v-card-title class="d-flex px-0 mx-4 justify-space-between align-center">
            <span class="text-h6">QA Task</span>
            <v-icon @click="close()" class="cursor-pointer">mdi-close</v-icon>
        </v-card-title>

        <v-form @submit.prevent="save" ref="topForm">
            <v-row class="d-flex align-center">
                <v-col cols="3" class="pb-0 px-5">
                    <v-radio-group inline v-model="formData.pass" class="custom-radio-group" :disabled="isViewMode">
                        <v-radio color="primary" label="Pass" value="1"></v-radio>
                        <v-radio color="error" label="Fail" value="0"></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col cols="4" class="pb-0 px-4" v-if="formData.pass === '0'">
                    <v-radio-group inline v-model="formData.qa_external" class="custom-radio-group" :disabled="isViewMode">
                        <v-radio color="primary" label="Internal" :value="1"></v-radio>
                        <v-radio color="error" label="External" :value="0"></v-radio>
                        <v-radio color="success" label="Client" :value="2"></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col :cols="issueQCstatus.qc_accept == null && issueQCstatus.qc_error == 1?'2':'2'" class="pb-0 px-4 d-flex align-center" v-if="formData.pass === '0'">
                    <v-checkbox
                        color="primary"
                        label="New Learning"
                        :model-value="formData.qa_new_learning === 1"
                        @update:model-value="formData.qa_new_learning = $event ? 1 : 0"
                        :disabled="isViewMode"
                    ></v-checkbox>
                </v-col>
                <v-col :cols="issueQCstatus.qc_accept == null && issueQCstatus.qc_error == 1?'2':'3'" class="pb-0 px-4 d-flex align-center" v-if="formData.pass === '0'">
                  <div>
                    <v-menu v-model="notificationMenu" :close-on-content-click="false" offset-y>
                        <template v-slot:activator="{ props }">
                            <!-- <v-badge class="ml-2" location="top start" :content="retestNotifications.length" color="red" :value="retestNotifications.length > 0"> -->
                                <v-icon v-bind="props" class="ml-4 cursor-pointer">mdi-bell</v-icon>
                            <!-- </v-badge> -->
                        </template>
                        <v-card min-width="300" max-width="400">
                            <v-card-title class="text-subtitle-1 pa-3">Retest notification</v-card-title>
                            <v-divider></v-divider>
                            <v-list v-if="retestNotifications.length > 0" max-height="300" style="overflow-y: auto;">
                                <v-list-item v-for="(notification, index) in retestNotifications" :key="index" class="pa-3" :class="{ 'position-relative': index === 0 }">
                                    <div v-if="index === 0 && issueQCstatus.qc_accept == null && issueQCstatus.qc_error == 1" class="position-absolute" style="top: 8px; right: 9px; width: 8px; height: 8px; background-color: orange; border-radius: 50%;"></div>
                                    <div v-if="index === 0 && issueQCstatus.qc_accept == 1 && issueQCstatus.qc_error == 0" class="position-absolute" style="top: 8px; right: 9px; width: 8px; height: 8px; background-color: green; border-radius: 50%;"></div>
                                    <div v-if="index === 0 && issueQCstatus.qc_accept == 0 && issueQCstatus.qc_error == 1" class="position-absolute" style="top: 8px; right: 9px; width: 8px; height: 8px; background-color: red; border-radius: 50%;"></div>
                                    <v-list-item-content>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ props }">
                                                <v-list-item-title v-bind="props" class="text-body-2 font-weight-medium cursor-pointer">{{ notification.description }}</v-list-item-title>
                                            </template>
                                            <span>{{ notification.description }}</span>
                                        </v-tooltip>
                                        <v-list-item-subtitle class="text-caption mt-1">{{ notification.action }}</v-list-item-subtitle>
                                       <!-- <v-list-item-subtitle class="text-caption text-grey mt-1">{{ notification.time }}</v-list-item-subtitle> -->
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-card-text v-else class="text-center text-grey pa-4">
                                No notifications
                            </v-card-text>
                        </v-card>
                    </v-menu>
                  </div>
                  <div>
                    <span>QC Status</span>
                    <v-chip v-if="issueQCstatus.qc_accept == 1 && issueQCstatus.qc_error == 0" color="green" class="ml-4">Accepted</v-chip>
                    <v-chip v-if="issueQCstatus.qc_accept == 0 && issueQCstatus.qc_error == 1" color="error" class="ml-4">Rejected</v-chip>
                    <v-chip v-if="issueQCstatus.qc_accept == null && issueQCstatus.qc_error == 1" color="orange" class="ml-4">Pending</v-chip>
                  </div>
                </v-col>
                <v-col cols="2" class="pb-0 px-4 d-flex align-center" v-if="formData.pass === '0' && issueQCstatus.qc_accept == null && issueQCstatus.qc_error == 1">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ props }">
                            <v-btn v-bind="props" size="small" color="success" class="mr-2 rounded-lg" @click="acceptQC">
                                <v-icon>mdi-check</v-icon>
                            </v-btn>
                        </template>
                        <span>Accept latest retest</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ props }">
                            <v-btn v-bind="props" size="small" color="error" class="rounded-lg" @click="rejectQC">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Reject latest retest</span>
                    </v-tooltip>
                </v-col>
            </v-row>
            <v-row class="mx-2 pb-3" :style="{borderBottom: formData.pass === '0' ? '1px solid #ccc' : 'none'}" >
                <v-col cols="3" class="py-0" v-if="formData.pass === '0'">
                    <v-label for="label"><b>Error Reported Date</b> <span style="color: red;">*</span> </v-label>
                    <!-- <TextFieldComponent 
                        :rules="getRules('Error Reported Date')"
                        type="date"
                        v-model="formData.error_reported_date"
                        :placeholder="'Code'"
                    /> -->
                     <!-- <TextFieldComponent density="compact" :placeholder="formData.error_reported_date" type="date" showtime :showReadOnly="showReadOnly || isViewMode"
               v-model="formData.error_reported_date" :rules="getRules('Error Reported Date')"/> -->
                    <DatePicker
                      v-model="formData.error_reported_date"
                      :placeholder="formData.error_reported_date"
                      :rules="getRules('Error Reported Date')"
                      @selectDate="forRevisionDate"
                      :showReadOnly="isViewMode"
                      :max-date="new Date()"
                    />              
                </v-col>

                <v-col cols="3" class="py-0 mb-2" v-if="formData.pass === '0' &&formData.qa_external == '2'">
                    <v-label for="label"><b>Client Contact Name</b> <span style="color: red;">*</span> </v-label>
                    <AutoComplete
                        :rules="getRules('Client Contact Name')"
                        placeholder="Client Contact Name"
                        v-model="formData.client_contact"
                        @update:model-value="$emit('userChanged', selectedUser)"
                        :items="clientData" 
                        item-value="id" 
                        item-title="name"
                        :disabled="isViewMode"
                    />
                </v-col>

                <v-col cols="3" class="py-0 " v-if="formData.pass === '0' && formData.qa_external != '2'">
                    <v-label for="label"><b>Error Made By</b> <span style="color: red;">*</span> </v-label>
                     <AutoComplete
                        :rules="getRules('Error Made By')"
                        placeholder="Error Made By"
                        v-model="formData.error_made_by"
                        @update:model-value="$emit('userChanged', selectedUser)"
                        item-value="id"
                        item-title="name"
                        :items="users"
                        :disabled="isViewMode"
                      />
                </v-col>               

                 <v-col cols="3" class="py-0" v-if="formData.pass === '0' && formData.qa_external != '2'">
                    <v-label for="label"><b>Error Reported by Name</b><span style="color: red;">*</span> </v-label>
                     <AutoComplete
                        :rules="getRules('Error Reported by Name')"
                        placeholder="Error Reported by Name"
                        v-model="formData.error_reported_by"
                        @update:model-value="$emit('userChanged', selectedUser)"
                        item-value="id"
                        item-title="name"
                        :items="erbData"
                        :disabled="isViewMode"
                      />
                </v-col>

                <v-col cols="3" class="py-0" v-if="(formData.pass === '1' || formData.pass === '0') && (formData.qa_external != '2' || formData.pass === '1')">
                    <v-label for="label"><b>Entry Person</b><span style="color: red;">*</span> </v-label>
                     <AutoComplete
                        :rules="getRules('Entry Person')"
                        placeholder="Entry Person"
                        v-model="formData.entry_person"
                        @update:model-value="$emit('userChanged', selectedUser)"
                        item-value="id"
                        item-title="name"
                        :items="entryUserData"
                      />
                </v-col>
                <v-col cols="3" class="py-0" v-if="formData.pass === '1'">
                    <v-label for="label"><b>QA person name</b><span style="color: red;">*</span> </v-label>
                        <AutoComplete :placeholder="'QA person name'" :items="qaApprovedUsersData" item-title="username"
                        :disabled="showReadOnly || isViewMode" item-value="id" v-model="formData.qa_user_id" :rules="getRules('QA person name')"
                    />
               </v-col>
            </v-row>

        </v-form>

        <div class="error-form mt-6"  v-if="formData.pass === '0' && (issueData.qa_task_retest == '1' || showSection == true) && formData.qa_external != '2'">
            <!-- Tab Headers -->
            <div class="tabs">
                <button
                    type="button"
                    v-for="tab in tabs"
                    :key="tab.name"
                    :class="['tab-btn', { active: currentTab === tab.name }]"
                    @click="forCurrentTab(tab)"
                    :disabled="isViewMode"
                >
                    {{ tab.name }}
                </button>
            </div>

            <!-- Tab Contents -->
            <v-form @submit.prevent="addRow" ref="tableForm">
                <v-row  v-if="formData.pass === '0'">
                    <v-col cols="12" class="tab-content mx-3">
                        <div v-if="currentTab">
                            <div class="d-flex">
                                <h3 :style="{ color: isFormDisabled ? '#9e9e9e' : '#000' }">{{ isFormDisabled? "Please Select Section":currentTab }}</h3>
                            </div>
                        </div>
                    </v-col>

                    <v-col cols="3" class="py-0 pl-6">
                        <v-label for="label"><b>Error Code</b><span style="color: red;">*</span> </v-label>
                        <AutoComplete
                            :rules="getRules('Error Code')"
                            placeholder="Error Code"
                            v-model="formData1.errorCode"
                            @update:model-value="$emit('userChanged', selectedUser)"
                            item-value="id"
                            item-title="name"
                            :items="errorCodeData"
                            :disabled="isFormDisabled"
                        />
                    </v-col>

                    <v-col cols="3" class="py-0">
                        <v-label for="label"><b>Error Severity [E]</b><span style="color: red;">*</span> </v-label>
                        <EnumAutoCompleteVue class="dropdown" density="compact" v-model="formData.severity"
                    :selected="formData.severity" :domain="'ERRORSEVERITY'" placeholder="Error severity" @changeEnumData="changeSeverty($event)"
                    :rules="getRules('Error Severity [E]')" :showReadOnly="isFormDisabled" />
                    </v-col>

                    <v-col cols="3" class="py-0">
                        <v-label for="label"><b>Error Type [E]</b><span style="color: red;">*</span> </v-label>
                        <EnumAutoCompleteVue class="dropdown" density="compact" v-model="formData.errorType"
                    :selected="formData1.errorType" :domain="'ERRORTYPE'" placeholder="Error type"
                    @changeEnumData="changeErrorType($event)" :rules="getRules('Error Type [E]')" :showReadOnly="isFormDisabled" />
                    </v-col>

                    <v-col cols="3" class="py-0">
                        <v-label for="label"><b>Error Category [E]</b><span style="color: red;">*</span> </v-label>
                        <EnumAutoCompleteVue class="dropdown" density="compact" v-model="formData.category_id"
                    :selected="formData1.errorCategory" :domain="'ERRORCATEGORY'" placeholder="Error category"
                    @changeEnumData="changeErrorCategory($event)" :rules="getRules('Error Category [E]')" :showReadOnly="isFormDisabled" />
                    </v-col>

                    <v-col cols="9" class="py-0 pl-6">
                        <v-label for="label"><b>Description</b><span style="color: red;">*</span> </v-label>
                        <v-textarea 
                            :rules="getRules('Description')"
                            placeholder="Description" 
                            variant='plain'
                            :rows="3"
                            v-model="formData1.description"
                            class="pl-4"
                            style="background-color: #ECECEC; border-radius: 5px;"
                            :disabled="isFormDisabled"
                        >
                        </v-textarea>
                    </v-col>
                    <v-col cols="1" class="mt-3 d-flex align-end">
                        <v-btn color="primary" type="submit" :disabled="isFormDisabled">Add</v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </div>

        
        <v-row  v-if="formData.pass === '0' && formData.qa_external != '2'">
            <v-container class="pl-6">
                <h3 class="mb-4 mt-2">Preview</h3>

                <v-card class="" variant="outlined" rounded="lg">
                    <v-table>
                    <thead>
                        <tr>
                        <th class="text-left">Section</th>
                        <th class="text-left">Error Severity</th>
                        <th class="text-left">Error Type [E]</th>
                        <th class="text-left">Error Category [E]</th>
                        <th class="text-left">Error Code</th>
                        <th class="text-left">Description</th>
                        <th class="text-left">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(sectionData, sectionId) in groupedTableData" :key="sectionId">
                            <tr>
                                <td colspan="7" style="background-color: #f5f5f5; font-weight: bold; padding: 8px 12px;">
                                    QC Attempt {{ sectionId }}
                                </td>
                            </tr>
                            <tr v-for="(data, dataIndex) in sectionData" :key="`${sectionId}-${dataIndex}`">
                                <td style="width: 100px;">
                                    <strong>{{data.section}}</strong>
                                </td>
                                <td style="width: 100px;">
                                    <div>{{ data.severity }}</div>
                                </td>
                                <td style="width: 130px;">
                                    <div>{{ data.errorType }}</div>
                                </td>
                                <td style="width: 150px;"> 
                                    <div>{{ data.errorCategory }}</div>
                                </td>
                                <td style="width: 150px;">
                                    <div>{{ data.errorCode }}</div>
                                </td>
                                <td style="width: 250px; word-wrap: break-word; white-space: normal;">
                                    <div style="max-width: 250px; word-wrap: break-word;">{{ data.description }}</div>
                                </td>
                                <td style="width: 20px;" v-if="!isViewMode && data.sectionId === currentSectionId">
                                    <v-icon @click="deleteItem(tableData.indexOf(data))">mdi-delete</v-icon>
                                </td>
                                <td style="width: 20px;" v-else></td>
                            </tr>
                        </template>
                    </tbody>
                    </v-table>
                </v-card>
                </v-container>
        </v-row>

        <v-row v-if="formData.pass === '1'" class="px-4">
          <v-col cols="2" class="d-flex align-center">
            <strong>Attachment</strong>
            <uploadFiles v-if="!showReadOnly && !isViewMode" @documentsData="documentsData($event)" :type="'icon'" class="ml-2" />
          </v-col>
           <v-col cols="12">
            <v-card-text
              v-if="documents && documents.length > 0 && !noDisplay"
            >
              <v-row justify="start">
                <v-chip
                  label
                  v-for="(item, index) in documents"
                  :key="index"
                  class="pa-3 mr-2 mb-2"
                >
                  <v-icon
                    @click="downloadDoc(item)"
                    size="small"
                    start
                    icon="mdi-download"
                  ></v-icon>
                  {{ item && item.doc_name ? item.doc_name : "" }}
                  <v-icon
                    v-if="item.type !== 'email' && !isViewMode"
                    class="ml-1"
                    @click.stop="docRemoved(item,index)"
                    size="small"
                    start
                    icon="mdi-close"
                  ></v-icon>
                </v-chip>
              </v-row>
            </v-card-text>
          </v-col>
        </v-row>

        <v-row v-if="formData.pass === '1'" class="px-4">
            <v-col cols="12">
            <v-label class="pb-1" style="font-size: 14px; color: #272727; font-weight: 800">Comment</v-label>
                <v-textarea variant="outlined" class="mt-1 text-Field" rows="1" v-model="formData.description" :disabled="showReadOnly || isViewMode"
                :rules="qaRemarkRule" ></v-textarea>
            </v-col>
        </v-row>

        <v-row justify="end" class="dialogBottom mb-3">
            <v-btn style=" --v-btn-height: 35px;" class="mr-2  adicancel" @click="close()">Cancel</v-btn>
            <v-btn style=" --v-btn-height: 35px;" class="save" @click="save" :loading="loader" :disabled="isViewMode">Save</v-btn>
        </v-row>
      </v-card>
    </v-dialog>
</template>

<script>
import uploadFiles from '@/components/uploadFiles.vue';
import AutoComplete from '../../components/ui/AutoComplete.vue'
// import TextFieldComponent from '@/components/TextFieldComponent.vue';
import EnumAutoCompleteVue from '@/components/others/EnumAutoComplete.vue';
import UserService from '@/api/service/UserService';
import ErrorLogsService from '@/api/service/ErrorLogs/ErrorLogsService';
import SectionCategoriesService from '@/api/service/SectionCategories/SectionCategoriesService';
import ErrorCodeService from '@/api/service/ErrorCode/ErrorCodeService';
import IssueService from '@/api/service/Issue/IssueService';
import documentService from '@/api/service/Document/DocumentService';
import moment from 'moment';
import DatePicker from "@/components/ui/DatePicker.vue";
import ForumService from '@/api/service/Forum/ForumService';
import ContactService from '@/api/service/Contact/ContactService';
// import TextArea from '../../components/ui/TextArea.vue'

export default {
    components:{
        // TextFieldComponent,
        AutoComplete,
        uploadFiles,
        DatePicker,
        // TextArea,
        EnumAutoCompleteVue,
    },
    props:["stage","issueData","viewType","showSection"],
    data(){
        return{
            dialog:true,
            notificationMenu: false,
            retestNotifications: [],
            tabs: [],
            errorCodeData: [],
            currentTab: "Header",
            bulkFormData: {},
            clientData:[],
            formData1:{
                errorCode:null,
                severity:null,
                errorType:null,
                errorCategory:null,
                description:null
            },
            formData:{
                pass:null,
                qa_external:'internal',
                qa_new_learning:null,
                error_reported_date: moment().format("YYYY-MM-DD"),
                error_made_by:null,
                severity:null,
                errorType:null,
                errorCategory:null,
                error_reported_by:null,
                entry_person:null,
                qaApprovedBy:null,
                score:null,
                qa_issue_id: null,
                preview_section: [],
                client_contact: null,
            },
            users:[],
            erbData:[],
            previewSectionValid: false,
            entryUserData:[],
            issueQCstatus:[],
            documents: [],
            qaApprovedUsersData:[],
            tableData:[],
            chips:[],
            userData: {},
            loader: false,
            currentSectionId: null,
            sideMenu : [
                            {
                                id:1,
                                name:'header'
                            },
                            {
                                id:2,
                                name:'Sales Rep'
                            },
                            {
                                id:3,
                                name:'Item'
                            },
                            {
                                id:4,
                                name:'Store'
                            },
                        ]
        }
    },
    computed: {
        isFormDisabled() {
            return this.currentTab === 'Header' || this.viewType === 'view';
        },
        isViewMode() {
            return this.viewType === 'view';
        },
        groupedTableData() {
            const grouped = {};
            this.tableData.forEach(item => {
                if (!grouped[item.sectionId]) {
                    grouped[item.sectionId] = [];
                }
                grouped[item.sectionId].push(item);
            });
            return grouped;
        }
    },
    created(){
        this.userData = JSON.parse(localStorage.getItem("user_details"))
        console.log(this.userData,"usdusdusdus2232");
        this.formData.entry_person = this.userData && this.userData.id? this.userData.id:null
        this.formData.qa_user_id = this.issueData.next_action
        console.log(this.issueData,"this.issueData%%%")
        this.getUser()
        if(this.issueData && this.issueData.id){
            this.getErrorLogData({qa_issue_id:this.issueData.id})
        }
        if(this.stage == 'qcpass'){
            this.formData.pass = "1"
        }
        else if(this.stage == 'qcfail'){
            this.formData.pass = "0"
        }
        this.getSectionCategories()
        // this.getErrorCode()
        this.contact()
    },

    methods:{
        moment,
        forRevisionDate(val) {
            this.formData.error_reported_date = moment(val).format('YYYY-MM-DD HH:mm:ss');
        },

        async contact (){
            await ContactService.allContacts().then((response) => {
                this.clientData = response
                // console.log(this.clientData,"clientData");
            }).catch((error) => {
                console.log(error);
            })
        },
        async forCurrentTab(tab){
            // alert(1)
            console.log(tab,"inside Tab");
            this.currentTab = tab.name
            this.getErrorCode({section: tab.id})
        },
        async getDocument() {
          try {
            let res = await documentService.getAllDocuments({
              doc_id: this.formData.attachment
            });
            this.documents = res;
            console.log(this.documents,"docc");
          } catch (e) {
            this.documents = [];
            console.log(e);
          }
        },
        documentsData($event) {
          this.formData.attachment =
            this.formData && this.formData.attachment
              ? JSON.parse(this.formData.attachment)
              : [];
          this.formData.attachment.push($event.id);
          this.formData.attachment = JSON.stringify(this.formData.attachment);
          this.getDocument();
        },
        acceptQC(){
            this.issueQCstatus.qc_accept = 1
            this.issueQCstatus.qc_error = 0
        },
        rejectQC(){
            this.issueQCstatus.qc_accept = 0
            this.issueQCstatus.qc_error = 1
        },
        downloadDoc(item) {
            documentService.download({ id: item.id }).then((response) => {
              console.log(response, "oooooooooooooooooopppp");
              window.open(response.url, "_blank");
            });
        },
        async docRemoved(item,index) {
            this.documents.splice(index, 1);
            let attachmentIds = this.formData.attachment ? JSON.parse(this.formData.attachment) : [];
            attachmentIds = attachmentIds.filter(id => id !== item.id);
            this.formData.attachment = JSON.stringify(attachmentIds);
            console.log(this.formData,"frmdt");

            let obj = {
              id: item.id,
              active: 0,
              deleted: 1,
            };
            await documentService.update(obj);
        },
        deleteItem(index){
            this.tableData.splice(index,1)
        },
        async getSectionCategories(){
            let response = await SectionCategoriesService.findAll({sub_category_id:this.issueData.sub_category_id})
            this.tabs = response
            console.log(response,"response");
        },
        async getErrorCode(obj){
            let response = await ErrorCodeService.getBySection(obj)
            // let response = await ErrorCodeService.findAll()
            this.errorCodeData = response.map(item => item.name)
            console.log(response,"response 1");
        },
        async getErrorLogData(obj) {
            let response = await ErrorLogsService.findAll(obj)
            delete response[0]?.pass
            console.log(response,"errlgg");
            if(response.length > 0){
                this.formData = {
                    description: response[0].description,
                    issue_id: response[0].issue_id,
                    entry_person: response[0].entry_person,
                    qa_user_id: response[0].qa_user_id? response[0].qa_user_id: this.issueData.next_action,
                    qa_issue_id: response[0].qa_issue_id,
                    error_reported_date: response[0].error_reported_date?moment(response[0].error_reported_date).utc().format("YYYY-MM-DD"):null,
                    error_made_by: response[0].error_made_by&&typeof(response[0].error_made_by)=='string'?JSON.parse(response[0].error_made_by):response[0].error_made_by,
                    error_reported_by: response[0].error_reported_by&&typeof(response[0].error_reported_by)=='string'?JSON.parse(response[0].error_reported_by):response[0].error_reported_by,
                    preview_section: typeof response[0].preview_section == 'string'? this.convertArray(response[0].preview_section): [],
                    attachment: response[0].attachment,
                    sub_category_id :response[0].sub_category_id,
                    score: response[0].score,
                    qa_new_learning: response[0].qa_new_learning,
                    qa_external: response[0].qa_external,
                    error_responsible_by: response[0].error_responsible_by,
                    client_contact: response[0].client_contact,
                    id: response[0].id,
                    pass: this.stage == 'qcpass'? '1':'0'
                }
                // this.tableData = this.formData.preview_section == null || this.formData.preview_section == undefined ? [] : []
                // if(this.tableData != null || this.tableData != undefined){
                //     this.convertArray(this.formData.preview_section)
                // }
                if(this.formData.attachment){
                    this.getDocument()
                }
                if(response[0].qc_reason != null){
                    this.issueQCstatus.qc_accept = response[0].qc_accept
                    this.issueQCstatus.qc_error = response[0].qc_error
                    this.issueQCstatus.qc_reason = JSON.parse(response[0].qc_reason)
                    let forumRes = await ForumService.getAllById({forumsId: this.issueQCstatus.qc_reason})
                    this.retestNotifications = forumRes
                    console.log(forumRes,"forumRes")
                }
                console.log(this.formData,"errldd");
                console.log(this.tableData,"errldd1");
                // this.tableData = new Array(this.tableData)
            }
        },
        close(data){
            if(data){
                this.$emit('close',data)
            }
            else{
                this.$emit('close')
            }
        },
        convertArray(data){
            let newData = JSON.parse(data)
            if(Array.isArray(newData)){
                this.formData.preview_section = newData
                this.tableData = newData
                return newData
            }
            else{
                this.convertArray(newData)
            }
        },

        
        async addRow() {
            let validation = await this.$refs.tableForm.validate();
            if (!validation.valid) {
                return;
            }
            
            if (!this.currentSectionId) {
                const maxSectionId = this.tableData.length > 0 ? Math.max(...this.tableData.map(item => item.sectionId || 0)) : 0;
                this.currentSectionId = maxSectionId + 1;
            }
            
            this.formData.section = this.currentTab;
            this.formData.sub_category_id = this.issueData.sub_category_id;
            this.formData.issue_id = this.issueData.parent_issue_id;
            this.formData.qa_issue_id = this.issueData.id
            this.formData.qa_new_learning = this.formData.qa_new_learning == true || this.formData.qa_new_learning == "true"? 1:0;
            delete this.formData.preview_section;
            
            this.tableData.push({
                sectionId: this.currentSectionId,
                section: this.formData.section,
                severity: this.formData.severity,
                errorType: this.formData.errorType,
                errorCategory: this.formData.errorCategory,
                errorCode: this.formData1.errorCode,
                description: this.formData1.description,
                created: moment().format("YYYY-MM-DD HH:mm:ss"),
                created_by: this.userData.id
            });

            console.log(this.tableData,"yyyyyyy!!!")

            this.formData.section = null;
            this.formData.severity = null;
            this.formData.errorType = null;
            this.formData.errorCategory = null;
            this.formData.errorCode = null;
            this.formData.description = null;

            this.formData.preview_section = this.tableData;
            this.formData.issue_id = this.issueData.id;
            // this.bulkFormData = this.formData;
            console.log(this.formData,"addingdata");
            this.$refs.tableForm.reset();
        },
        changeSeverty($event) {
        this.formData.severity = $event
        },
        changeErrorType($event) {
        this.formData.errorType = $event
        },
        changeErrorCategory($event) {
        this.formData.errorCategory = $event
        },
        async save(){

            let validation = await this.$refs.topForm.validate();
            // let validatetableForm = await this.$refs.tableForm.validate();
            // console.log(this.groupedTableData,"this.groupedTableData")
            if(Object.keys(this.groupedTableData).length == 0 && this.formData.pass === '0' && this.formData.qa_external != '2'){
                this.$store.dispatch("setSnackbar", { text: "Please update the Error section", color: "error" });
                return;
            }
            if (!validation.valid) {
                this.$store.dispatch("setSnackbar", { text: "Please fill all required fields", color: "error" });
                return;
            }
            
            console.log(this.formData,"savvve1");
            if(this.formData.id){
                this.loader = true
                    delete this.formData.severity
                    delete this.formData.errorType
                    delete this.formData.errorCategory
                    delete this.formData.errorCode
                    delete this.formData.section
                    this.formData.issue_id = this.issueData.parent_issue_id
                    this.formData.qa_issue_id = this.issueData.id
                    this.formData.qa_user_id = this.formData.qa_user_id? this.formData.qa_user_id: this.issueData.next_action
                    this.formData.sub_category_id = this.issueData.sub_category_id
                    this.formData.qc_accept = this.issueQCstatus.qc_accept
                    this.formData.qc_error = this.issueQCstatus.qc_error 
                    this.formData.qc_reason = this.issueQCstatus.qc_reason && this.issueQCstatus.qc_reason.length > 0? JSON.stringify(this.issueQCstatus.qc_reason):'[]'
                    console.log(this.formData.preview_section,'this.formData.preview_section') 
                    // console.log(JSON.stringify(this.formData), 'JSON Update') 
                    let res = await ErrorLogsService.update(this.formData)
                    let issueRes = await IssueService.update({id:this.issueData.id, stage: this.formData.pass == "1"? "qcpass":"qcfail"})
                    console.log(issueRes,"issueRes");
                    console.log(res);
                    this.currentSectionId = (this.currentSectionId || 1) + 1;
                    this.loader = false
                    this.$store.dispatch("setSnackbar", { text: "Saved Successfully" });
                    // let $data = {stage: this.formData.pass == '1'? 'qcpass': 'qcfail', fromQAtask: true}
                    // await this.$emit('updateData',$data)
                    if(this.issueQCstatus.qc_reason && this.issueQCstatus.qc_reason.length > 0){
                        let latestRetest = Math.max(...this.issueQCstatus.qc_reason);
                        let newComment = this.retestNotifications.find(item => item.id == latestRetest);
                        let data = {
                            key_type: "issue",
                            key_id: this.formData.qa_issue_id ,
                            action: "QC-Retest",
                            description:  `${this.userData.username} was ${this.issueQCstatus.qc_accept == 1 && this.issueQCstatus.qc_error == 0?'accepted':'rejected'} the retest ~ ${newComment?.description || ''}`,
                        };
                        let forumResponse = await ForumService.create(data);
                        console.log(forumResponse,"fromForums");
                    }
                    this.close(this.formData)
            }
            else if(!this.formData.id) {
                this.loader = true
                delete this.formData.severity
                delete this.formData.errorType
                delete this.formData.errorCategory
                delete this.formData.errorCode
                delete this.formData.section
                this.formData.issue_id = this.issueData.parent_issue_id
                this.formData.qa_issue_id = this.issueData.id
                this.formData.qa_user_id = this.formData.qa_user_id? this.formData.qa_user_id: this.issueData.next_action
                this.formData.sub_category_id = this.issueData.sub_category_id
                // this.formData.qa_issue_id = this.issueData.id
                // console.log(JSON.stringify(this.formData), 'JSON Create') 
                // console.log(this.formData,"iiiiooooo")
                let res = await ErrorLogsService.create(this.formData)
                console.log(res,"savvve");
                this.currentSectionId = (this.currentSectionId || 1) + 1;
                this.loader = false
                this.$store.dispatch("setSnackbar", { text: "Saved Successfully" });
                // let $data = {stage: this.formData.pass == '1'? 'qcpass': 'qcfail', fromQAtask: true}
                // await this.$emit('updateData',$data)
                this.close(this.formData)
            }
            this.getErrorLogData()
        },
        async getUser() {
            let $res = await UserService.findAll()
            this.users = $res && $res.length>0 ? this.getStringfyTheData($res) : []
            this.erbData = $res && $res.length>0 ? this.getStringfyTheData($res) : []
            this.entryUserData = $res && $res.length>0 ? this.getStringfyTheData($res) : []
            this.qaApprovedUsersData = $res && $res.length>0 ? this.getStringfyTheData($res) : []
            this.$forceUpdate()
            // this.formData.userName = $res && $res.length > 0 ? $res[0].name : ''
        },

        getStringfyTheData(data){
            return JSON.parse(JSON.stringify(data))
        },

        getRules(name) {
            if (name && name.toLowerCase() === "email") {
                return [
                    (v) => !!v || "E-mail is required.",
                    (v) => /.+@.+\..+/.test(v) || "E-mail must be valid.",
                ];
            }
            return [(v) => !!v || `${name} is required.`];
        },
        confirm(){
            console.log(this.formData.orderNum,'orderNum!!!!')
        },
        addChip() {
            if (this.formData.so.trim() !== '') {
                this.chips.push(this.formData.so);
                this.formData.so = '';
                console.log(this.chips,"this.chips!!")
            }
        },
        removeChip(index) {
            this.chips.splice(index, 1);
            console.log(this.chips,"delete!!")
        },

        deleteAll(){
            this.chips = []
        },
    }
}
</script>

<style scoped>
.v-field__input{
    
}
.v-card {
  border: 1px solid #d0d0d0 !important;
  border-radius: 12px;
}

.v-table {
  border-collapse: collapse;
}

.v-table th {
  font-weight: 600;
  background-color: #fafafa;
}

.v-table th,
.v-table td {
  padding: 12px;
  vertical-align: middle;
  border-bottom: 1px solid #e0e0e0;
}


::v-deep(.v-chip__close) {
  color: #204887 !important;
}
.search-bar {
  height: 26px !important;
}
.chpis{
    border: 1px solid #a19e9e;
    min-height: 200px;
    max-height: 200px;
    border-radius: 5px;
    
}
.ch{
  
    margin: auto;
    overflow-y: auto;
    min-height: 130px;
    max-height: 130px; 
    overflow-x: hidden; 
}
.so{
    display: flex;
    justify-content: space-between;
}
.add{
    display: flex;
    gap: 10px;
}
.v-selection-control .v-label {
  font-size: 26px !important; 
  margin-left: 8px;
}



.tabs {
  display: flex;
  /* border-bottom: 2px solid #ddd; */
  margin-bottom: 10px;
}

.tab-btn {
  padding: 10px 18px;
  cursor: pointer;
  border: none;
  /* background: #f9fafb; */
  font-weight: 500;
  border-radius: 6px 6px 0 0;
  margin-right: 4px;
  transition: 0.2s ease;
}

.tab-btn:hover {
  /* background: #eef2ff; */
}

.tab-btn.active {
  color: #3b82f6;
  /* color: white; */
}

/* Tab Content */
.tab-content {
  /* border: 1px solid #ddd; */
  padding: 16px;
  border-radius: 0 6px 6px 6px;
  background: white;
}
</style>